import BaseTags from "./BaseTags.vue";

export default BaseTags;
